export const currencies = {
  USD: {
    name: 'United States Dollar',
    code: 'USD',
    countries: ['United States', 'USA'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/usd-1-cent.png'
    }]
  },
  GBP: {
    name: 'Pound Sterling',
    code: 'GBP',
    countries: ['United Kingdom'],
    symbol: {
      char: '£',
      pre: true
    },
    maxDP: 2,
    units: {
      'penny': {
        name: 'penny',
        plural: 'pence',
        symbol: {
          char: 'p',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'penny',
      units: 1,
      img: '/img/coins/gbp-1-penny.png'
    }]
  },
  EUR: {
    name: 'Euro',
    code: 'EUR',
    countries: [
      'European Union',
      'Austria',
      'Belgium',
      'Cyprus',
      'Estonia',
      'Finland',
      'France',
      'Germany',
      'Greece',
      'Ireland',
      'Italy',
      'Latvia',
      'Lithuania',
      'Luxembourg',
      'Malta',
      'Netherlands',
      'Portugal',
      'Slovakia',
      'Slovenia',
      'Spain',
      'Andorra',
      'Monaco',
      'San Marino',
      'Vatican City',
      'Kosovo',
      'Montenegro'
    ],
    symbol: {
      char: '€',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/eur-1-cent.png'
    }]
  },
  CNY: {
    name: 'Chinese Yuan',
    code: 'CNY',
    countries: ['China'],
    symbol: {
      char: '¥',
      pre: true
    },
    maxDP: 2,
    units: {
      'fen': {
        name: 'fen',
        plural: 'fen',
        symbol: {
          char: '分',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'fen',
      units: 1,
      img: '/img/coins/cny-1-fen.png'
    }]
  },
  JPY: {
    name: 'Japanese Yen',
    code: 'JPY',
    countries: ['Japan'],
    symbol: {
      char: '¥',
      pre: true
    },
    maxDP: 2,
    units: {
      'yen': {
        name: 'yen',
        plural: 'yen',
        symbol: {
          char: '¥',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'yen',
      units: 1,
      img: '/img/coins/jpy-1-yen.png'
    }]
  },
  INR: {
    name: 'Indian Rupee',
    code: 'INR',
    countries: ['India', 'Bhutan'],
    symbol: {
      char: '₹',
      pre: true
    },
    maxDP: 2,
    units: {
      'paisa': {
        name: 'paisa',
        plural: 'paisa',
        symbol: {
          char: 'p',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'paisa',
      units: 50,
      img: '/img/coins/inr-50-paisa.png'
    }]
  },
  RUB: {
    name: 'Russian Ruble',
    code: 'RUB',
    countries: ['Russia'],
    symbol: {
      char: '₽',
      pre: false
    },
    maxDP: 2,
    units: {
      'kopek': {
        name: 'kopek',
        plural: 'kopek',
        symbol: {
          char: 'к',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'kopek',
      units: 1,
      img: '/img/coins/rub-1-kopek.png'
    }]
  },
  KRW: {
    name: 'Korean Won',
    code: 'KRW',
    countries: ['South Korea'],
    symbol: {
      char: '₩',
      pre: true
    },
    maxDP: 2,
    units: {
      'won': {
        name: 'won',
        plural: 'won',
        symbol: {
          char: '₩',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'won',
      units: 1,
      img: '/img/coins/krw-1-won.png'
    }]
  },
  CHF: {
    name: 'Swiss Franc',
    code: 'CHF',
    countries: ['Switzerland'],
    symbol: {
      char: 'fr.',
      pre: false
    },
    maxDP: 2,
    units: {
      'centime': {
        name: 'centime',
        plural: 'centimes',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centime',
      units: 5,
      img: '/img/coins/chf-5-centime.png'
    }]
  },
  BRL: {
    name: 'Brazilian Real',
    code: 'BRL',
    countries: ['Brazil'],
    symbol: {
      char: 'R$',
      pre: true
    },
    maxDP: 2,
    units: {
      'centavo': {
        name: 'centavo',
        plural: 'centavos',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centavo',
      units: 5,
      img: '/img/coins/brl-5-centavo.png'
    }]
  },
  MXN: {
    name: 'Mexican Peso',
    code: 'MXN',
    countries: ['México'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'centavo': {
        name: 'centavo',
        plural: 'centavos',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centavo',
      units: 10,
      img: '/img/coins/mxn-10-centavo.png'
    }]
  },
  CAD: {
    name: 'Canadian Dollar',
    code: 'CAD',
    countries: ['Canada'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/cad-1-cent.png'
    }]
  },
  AUD: {
    name: 'Australian Dollar',
    code: 'AUD',
    countries: ['Australia'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/aud-1-cent.png'
    }]
  },
  HKD: {
    name: 'Hong Kong Dollar',
    code: 'HKD',
    countries: ['Hong Kong'],
    symbol: {
      char: 'HK$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 10,
      img: '/img/coins/hkd-10-cent.png'
    }]
  },
  SAR: {
    name: 'Saudi Riyal',
    code: 'SAR',
    countries: ['Saudi Arabia'],
    symbol: {
      char: '﷼',
      pre: false
    },
    maxDP: 2,
    units: {
      'halala': {
        name: 'halala',
        plural: 'halalas',
        symbol: {
          char: 'هللة‎',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'halala',
      units: 1,
      img: '/img/coins/sar-1-halala.png'
    }]
  },
  TRY: {
    name: 'Turkish Lira',
    code: 'TRY',
    countries: ['Turkey'],
    symbol: {
      char: '₺',
      pre: true
    },
    maxDP: 2,
    units: {
      'kurus': {
        name: 'kuruş',
        plural: 'kuruş',
        symbol: {
          char: 'kr',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'kurus',
      units: 1,
      img: '/img/coins/try-1-kurus.png'
    }]
  },
  SGD: {
    name: 'Singapore Dollar',
    code: 'SGD',
    countries: ['Singapore'],
    symbol: {
      char: 'S$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/sgd-1-cent.png'
    }]
  },
  ZAR: {
    name: 'South African Rand',
    code: 'ZAR',
    countries: ['South Africa', 'Lesotho', 'Namibia', 'Eswatini'],
    symbol: {
      char: 'R',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/zar-1-cent.png'
    }]
  },
  SEK: {
    name: 'Swedish Krona',
    code: 'SEK',
    countries: ['Sweden'],
    symbol: {
      char: 'kr',
      pre: false
    },
    maxDP: 2,
    units: {
      'krona': {
        name: 'krona',
        plural: 'kronor',
        symbol: {
          char: 'kr',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'krona',
      units: 1,
      img: '/img/coins/sek-1-krona.png'
    }]
  },
  Ecuador: {
    name: 'US Dollar',
    code: 'Ecuador',
    fxCode: 'USD',
    countries: ['Ecuador'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'centavo': {
        name: 'centavo',
        plural: 'centavos',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centavo',
      units: 1,
      img: '/img/coins/eusd-1-centavo.png'
    }]
  },
  AED: {
    name: 'Emirati Dirham',
    code: 'AED',
    countries: ['United Arab Emirates'],
    symbol: {
      char: 'د.إ',
      pre: false
    },
    maxDP: 2,
    units: {
      'fils': {
        name: 'fils',
        plural: 'fils',
        symbol: {
          char: 'فلس',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'fils',
      units: 25,
      img: '/img/coins/aed-25-fils.png'
    }]
  },
  AFN: {
    name: 'Afghan Afghani',
    code: 'AFN',
    countries: ['Afghanistan'],
    symbol: {
      char: '؋',
      pre: false
    },
    maxDP: 2,
    units: {
      'afghani': {
        name: 'afghani',
        plural: 'afghanis',
        symbol: {
          char: '؋',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'afghani',
      units: 1,
      img: '/img/coins/afn-1-afghani.png'
    }]
  },
  ALL: {
    name: 'Albanian Lek',
    code: 'ALL',
    countries: ['Albania'],
    symbol: {
      char: 'L',
      pre: false
    },
    maxDP: 2,
    units: {
      'lek': {
        name: 'lek',
        plural: 'leke',
        symbol: {
          char: 'L',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'lek',
      units: 1,
      img: '/img/coins/all-1-lek.png'
    }]
  },
  AMD: {
    name: 'Armenian Dram',
    code: 'AMD',
    countries: ['Armenia'],
    symbol: {
      char: '֏',
      pre: false
    },
    maxDP: 2,
    units: {
      'luma': {
        name: 'luma',
        plural: 'luma',
        symbol: {
          char: 'L',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'luma',
      units: 10,
      img: '/img/coins/amd-10-luma.png'
    }]
  },
  ANG: {
    name: 'Dutch Guilder',
    code: 'ANG',
    countries: ['Dutch Antilles', 'Sint Maarten', 'Curaçao', 'Bonaire'],
    symbol: {
      char: 'ƒ',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/ang-1-cent.png'
    }]
  },
  AWG: {
    name: 'Aruban Florin',
    code: 'AWG',
    fxCode: 'ANG',
    countries: ['Aruba'],
    symbol: {
      char: 'ƒ',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 5,
      img: '/img/coins/awg-5-cent.png'
    }]
  },
  AOA: {
    name: 'Angolan Kwanza',
    code: 'AOA',
    countries: ['Angola'],
    symbol: {
      char: 'Kz',
      pre: false
    },
    maxDP: 2,
    units: {
      'centimo': {
        name: 'cêntimo',
        plural: 'cêntimos',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centimo',
      units: 10,
      img: '/img/coins/aoa-10-centimo.png'
    }]
  },
  ARS: {
    name: 'Argentine Peso',
    code: 'ARS',
    countries: ['Argentina'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'centavo': {
        name: 'centavo',
        plural: 'centavos',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centavo',
      units: 1,
      img: '/img/coins/ars-1-centavo.png'
    }]
  },
  AZN: {
    name: 'Azerbaijani Manat',
    code: 'AZN',
    countries: ['Azerbaijan'],
    symbol: {
      char: '₼',
      pre: false
    },
    maxDP: 2,
    units: {
      'qapik': {
        name: 'qəpik',
        plural: 'qəpik',
        symbol: {
          char: 'q',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'qapik',
      units: 1,
      img: '/img/coins/azn-1-qapik.png'
    }]
  },
  BAM: {
    name: 'Bosnia and Herzegovina Convertible Mark',
    code: 'BAM',
    countries: ['Bosnia and Herzegovina'],
    symbol: {
      char: 'KM',
      pre: false
    },
    maxDP: 2,
    units: {
      'fening': {
        name: 'fening',
        plural: 'feninga',
        symbol: {
          char: 'pf',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'fening',
      units: 5,
      img: '/img/coins/bam-5-fening.png'
    }]
  },
  BBD: {
    name: 'Barbados Dollar',
    code: 'BBD',
    countries: ['Barbados'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/bbd-1-cent.png'
    }]
  },
  BDT: {
    name: 'Bangladeshi Taka',
    code: 'BDT',
    countries: ['Bangladesh'],
    symbol: {
      char: '৳',
      pre: true
    },
    maxDP: 2,
    units: {
      'poysha': {
        name: 'poysha',
        plural: 'poysha',
        symbol: {
          char: 'p',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'poysha',
      units: 10,
      img: '/img/coins/bdt-10-poysha.png'
    }]
  },
  BGN: {
    name: 'Bulgarian Lev',
    code: 'BGN',
    countries: ['Bulgaria'],
    symbol: {
      char: 'лв.',
      pre: false
    },
    maxDP: 2,
    units: {
      'stotinka': {
        name: 'stotinka',
        plural: 'stotinki',
        symbol: {
          char: 'ст.',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'stotinka',
      units: 1,
      img: '/img/coins/bgn-1-stotinka.png'
    }]
  },
  BHD: {
    name: 'Bahraini Dinar',
    code: 'BHD',
    countries: ['Bahrain'],
    symbol: {
      char: 'د.ب',
      pre: false
    },
    maxDP: 3,
    units: {
      'fils': {
        name: 'fils',
        plural: 'fils',
        symbol: {
          char: 'فلس',
          pre: false
        },
        value: 0.001
      }
    },
    coins: [{
      unit: 'fils',
      units: 5,
      img: '/img/coins/bhd-5-fils.png'
    }]
  },
  BIF: {
    name: 'Burundian Franc',
    code: 'BIF',
    countries: ['Burundi'],
    symbol: {
      char: 'FBu',
      pre: false
    },
    maxDP: 2,
    units: {
      'franc': {
        name: 'franc',
        plural: 'francs',
        symbol: {
          char: 'FBu',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'franc',
      units: 1,
      img: '/img/coins/bif-1-franc.png'
    }]
  },
  BMD: {
    name: 'Bermudian Dollar',
    code: 'BMD',
    fxCode: 'USD',
    countries: ['Bermuda'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/bmd-1-cent.png'
    }]
  },
  BND: {
    name: 'Brunei Dollar',
    code: 'BND',
    fxCode: 'SGD',
    countries: ['Brunei'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'sen': {
        name: 'sen',
        plural: 'sen',
        symbol: {
          char: 's',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'sen',
      units: 1,
      img: '/img/coins/bnd-1-sen.png'
    }]
  },
  BOB: {
    name: 'Bolivian Boliviano',
    code: 'BOB',
    countries: ['Bolivia'],
    symbol: {
      char: 'Bs',
      pre: true
    },
    maxDP: 2,
    units: {
      'centavo': {
        name: 'centavo',
        plural: 'centavos',
        symbol: {
          char: 'c.',
          pre: true
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centavo',
      units: 10,
      img: '/img/coins/bob-10-centavo.png'
    }]
  },
  BSD: {
    name: 'Bahamian Dollar',
    code: 'BSD',
    fxCode: 'USD',
    countries: ['The Bahamas'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/bsd-1-cent.png'
    }]
  },
  ElSalvador: {
    name: 'Bitcoin',
    code: 'ElSalvador',
    altCode: 'El Salvador',
    fxCode: 'BTC',
    countries: ['El Salvador', 'BTC'],
    symbol: {
      char: '₿',
      pre: true
    },
    maxDP: 8,
    units: {
      'satoshi': {
        name: 'satoshi',
        plural: 'satoshis',
        symbol: {
          char: '',
          pre: true
        },
        value: 0.00000001
      }
    },
    coins: [{
      unit: 'satoshi',
      units: 1,
      img: '/img/coins/satoshi-coin.svg'
    }]
  },
  CentralAfricanRepublic: {
    name: 'Bitcoin',
    code: 'CentralAfricanRepublic',
    altCode: 'Central African Republic',
    fxCode: 'BTC',
    countries: ['CAR', 'Central African Republic', 'BTC'],
    symbol: {
      char: '₿',
      pre: true
    },
    maxDP: 8,
    units: {
      'satoshi': {
        name: 'satoshi',
        plural: 'satoshis',
        symbol: {
          char: '',
          pre: true
        },
        value: 0.00000001
      }
    },
    coins: [{
      unit: 'satoshi',
      units: 1,
      img: '/img/coins/satoshi-coin.svg'
    }]
  },
  BTN: {
    name: 'Bhutanese Ngultrum',
    code: 'BTN',
    fxCode: 'INR',
    countries: ['Bhutan'],
    symbol: {
      char: 'Nu.',
      pre: true
    },
    maxDP: 2,
    units: {
      'chhertum': {
        name: 'chhertum',
        plural: 'chhertum',
        symbol: {
          char: 'Ch.',
          pre: true
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'chhertum',
      units: 20,
      img: '/img/coins/btn-20-chhertum.png'
    }]
  },
  BWP: {
    name: 'Botswana Pula',
    code: 'BWP',
    countries: ['Botswana'],
    symbol: {
      char: 'P',
      pre: true
    },
    maxDP: 2,
    units: {
      'thebe': {
        name: 'thebe',
        plural: 'thebe',
        symbol: {
          char: 't',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'thebe',
      units: 5,
      img: '/img/coins/bwp-5-thebe.png'
    }]
  },
  BYN: {
    name: 'Belarusian Ruble',
    code: 'BYN',
    countries: ['Belarus'],
    symbol: {
      char: 'Br',
      pre: false
    },
    maxDP: 2,
    units: {
      'copeck': {
        name: 'copeck',
        plural: 'copecks',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'copeck',
      units: 1,
      img: '/img/coins/byn-1-copeck.png'
    }]
  },
  BZD: {
    name: 'Belize Dollar',
    code: 'BZD',
    fxCode: 'USD',
    countries: ['Belize'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/bzd-1-cent.png'
    }]
  },
  CLP: {
    name: 'Chilean Peso',
    code: 'CLP',
    countries: ['Chile'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'peso': {
        name: 'peso',
        plural: 'pesos',
        symbol: {
          char: '$',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'peso',
      units: 1,
      img: '/img/coins/clp-1-peso.png'
    }]
  },
  COP: {
    name: 'Colombian Peso',
    code: 'COP',
    countries: ['Colombia'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'peso': {
        name: 'peso',
        plural: 'pesos',
        symbol: {
          char: '$',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'peso',
      units: 20,
      img: '/img/coins/cop-20-peso.png'
    }]
  },
  CRC: {
    name: 'Costa Rican Colon',
    code: 'CRC',
    countries: ['Costa Rica'],
    symbol: {
      char: '₡',
      pre: true
    },
    maxDP: 2,
    units: {
      'colon': {
        name: 'colon',
        plural: 'colones',
        symbol: {
          char: '₡',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'colon',
      units: 5,
      img: '/img/coins/crc-5-colon.png'
    }]
  },
  CUP: {
    name: 'Cuban Peso',
    code: 'CUP',
    countries: ['Cuba'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'centavo': {
        name: 'centavo',
        plural: 'centavos',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centavo',
      units: 1,
      img: '/img/coins/cup-1-centavo.png'
    }]
  },
  CVE: {
    name: 'Cape Verdean Escudo',
    code: 'CVE',
    countries: ['Cape Verde'],
    symbol: {
      char: '$',
      middle: true,
      pre: false
    },
    maxDP: 2,
    units: {
      'escudo': {
        name: 'escudo',
        plural: 'escudos',
        symbol: {
          char: '$',
          middle: true,
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'escudo',
      units: 1,
      img: '/img/coins/cve-1-escudo.png'
    }]
  },
  CZK: {
    name: 'Czech Koruna',
    code: 'CZK',
    countries: ['Czechia'],
    symbol: {
      char: 'Kč',
      pre: false
    },
    maxDP: 2,
    units: {
      'koruna': {
        name: 'koruna',
        plural: 'korun',
        symbol: {
          char: 'Kč',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'koruna',
      units: 1,
      img: '/img/coins/czk-1-koruna.png'
    }]
  },
  DJF: {
    name: 'Djiboutian Franc',
    code: 'DJF',
    countries: ['Djibouti'],
    symbol: {
      char: 'Fdj',
      pre: false
    },
    maxDP: 2,
    units: {
      'franc': {
        name: 'franc',
        plural: 'francs',
        symbol: {
          char: 'Fdj',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'franc',
      units: 1,
      img: '/img/coins/djf-1-franc.png'
    }]
  },
  DKK: {
    name: 'Danish Krone',
    code: 'DKK',
    countries: ['Denmark'],
    symbol: {
      char: 'kr.',
      pre: false
    },
    maxDP: 2,
    units: {
      'ore': {
        name: 'øre',
        plural: 'øre',
        symbol: {
          char: 'ø',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'ore',
      units: 50,
      img: '/img/coins/dkk-50-ore.png'
    }]
  },
  DOP: {
    name: 'Dominican Peso',
    code: 'DOP',
    countries: ['Dominican Republic'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'centavo': {
        name: 'centavo',
        plural: 'centavos',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centavo',
      units: 1,
      img: '/img/coins/dop-1-centavo.png'
    }]
  },
  DZD: {
    name: 'Algerian Dinar',
    code: 'DZD',
    countries: ['Algeria'],
    symbol: {
      char: 'دج',
      pre: false
    },
    maxDP: 2,
    units: {
      'dinar': {
        name: 'dinar',
        plural: 'dinars',
        symbol: {
          char: 'دج',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'dinar',
      units: 1,
      img: '/img/coins/dzd-1-dinar.png'
    }]
  },
  EGP: {
    name: 'Egyptian Pound',
    code: 'EGP',
    countries: ['Egypt'],
    symbol: {
      char: '£',
      pre: true
    },
    maxDP: 2,
    units: {
      'piastre': {
        name: 'piastre',
        plural: 'piastre',
        symbol: {
          char: 'pt.',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'piastre',
      units: 25,
      img: '/img/coins/egp-25-piastre.png'
    }]
  },
  ERN: {
    name: 'Eritrean Nakfa',
    code: 'ERN',
    countries: ['Eritrea'],
    symbol: {
      char: 'ናቕፋ',
      pre: false
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/ern-1-cent.png'
    }]
  },
  ETB: {
    name: 'Ethiopian Birr',
    code: 'ETB',
    countries: ['Ethiopia'],
    symbol: {
      char: 'ብር',
      pre: false
    },
    maxDP: 2,
    units: {
      'santim': {
        name: 'santim',
        plural: 'santim',
        symbol: {
          char: 's',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'santim',
      units: 1,
      img: '/img/coins/etb-1-santim.png'
    }]
  },
  FJD: {
    name: 'Fijian Dollar',
    code: 'FJD',
    countries: ['Fiji'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/fjd-1-cent.png'
    }]
  },
  GEL: {
    name: 'Georgian Lari',
    code: 'GEL',
    countries: ['Georgia'],
    symbol: {
      char: '₾',
      pre: false
    },
    maxDP: 2,
    units: {
      'tetri': {
        name: 'tetri',
        plural: 'tetri',
        symbol: {
          char: 'თ',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'tetri',
      units: 1,
      img: '/img/coins/gel-1-tetri.png'
    }]
  },
  GHS: {
    name: 'Ghanaian Cedi',
    code: 'GHS',
    countries: ['Ghana'],
    symbol: {
      char: '₵',
      pre: true
    },
    maxDP: 2,
    units: {
      'pesewa': {
        name: 'pesewa',
        plural: 'pesewas',
        symbol: {
          char: 'Gp',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'pesewa',
      units: 1,
      img: '/img/coins/ghs-1-pesewa.png'
    }]
  },
  GMD: {
    name: 'Gambian Dalasi',
    code: 'GMD',
    countries: ['The Gambia'],
    symbol: {
      char: 'D',
      pre: false
    },
    maxDP: 2,
    units: {
      'dalasi': {
        name: 'dalasi',
        plural: 'dalasi',
        symbol: {
          char: 'D',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'dalasi',
      units: 1,
      img: '/img/coins/gmd-1-dalasi.png'
    }]
  },
  GNF: {
    name: 'Guinean Franc',
    code: 'GNF',
    countries: ['Guinea'],
    symbol: {
      char: 'FG',
      pre: false
    },
    maxDP: 2,
    units: {
      'franc': {
        name: 'franc',
        plural: 'francs',
        symbol: {
          char: 'FG',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'franc',
      units: 1,
      img: '/img/coins/gnf-1-franc.png'
    }]
  },
  GTQ: {
    name: 'Guatemalan Quetzal',
    code: 'GTQ',
    countries: ['Guatemala'],
    symbol: {
      char: 'Q',
      pre: false
    },
    maxDP: 2,
    units: {
      'centavo': {
        name: 'centavo',
        plural: 'centavos',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centavo',
      units: 1,
      img: '/img/coins/gtq-1-centavo.png'
    }]
  },
  GYD: {
    name: 'Guyanese Dollar',
    code: 'GYD',
    countries: ['Guyana'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/gyd-1-cent.png'
    }]
  },
  HNL: {
    name: 'Honduran Lempira',
    code: 'HNL',
    countries: ['Honduras'],
    symbol: {
      char: 'L',
      pre: true
    },
    maxDP: 2,
    units: {
      'centavo': {
        name: 'centavo',
        plural: 'centavos',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centavo',
      units: 5,
      img: '/img/coins/hnl-5-centavo.png'
    }]
  },
  HRK: {
    name: 'Croatian Kuna',
    code: 'HRK',
    countries: ['Croatia'],
    symbol: {
      char: 'kn',
      pre: false
    },
    maxDP: 2,
    units: {
      'lipa': {
        name: 'lipa',
        plural: 'lipa',
        symbol: {
          char: 'lp',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'lipa',
      units: 1,
      img: '/img/coins/hrk-1-lipa.png'
    }]
  },
  HTG: {
    name: 'Haitian Gourde',
    code: 'HTG',
    countries: ['Haiti'],
    symbol: {
      char: 'G',
      pre: false
    },
    maxDP: 2,
    units: {
      'centime': {
        name: 'centime',
        plural: 'centimes',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centime',
      units: 5,
      img: '/img/coins/htg-5-centime.png'
    }]
  },
  HUF: {
    name: 'Hungarian Forint',
    code: 'HUF',
    countries: ['Hungary'],
    symbol: {
      char: 'Ft',
      pre: false
    },
    maxDP: 2,
    units: {
      'forint': {
        name: 'forint',
        plural: 'forints',
        symbol: {
          char: 'Ft',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'forint',
      units: 1,
      img: '/img/coins/huf-1-forint.png'
    }]
  },
  IDR: {
    name: 'Indonesian Rupiah',
    code: 'IDR',
    countries: ['Indonesian'],
    symbol: {
      char: 'Rp',
      pre: true
    },
    maxDP: 2,
    units: {
      'rupiah': {
        name: 'rupiah',
        plural: 'rupiah',
        symbol: {
          char: 'Rp',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'rupiah',
      units: 50,
      img: '/img/coins/idr-50-rupiah.png'
    }]
  },
  ILS: {
    name: 'Israeli New Shekel',
    code: 'ILS',
    countries: ['Israel'],
    symbol: {
      char: '₪',
      pre: true
    },
    maxDP: 2,
    units: {
      'agora': {
        name: 'agora',
        plural: 'agorot',
        symbol: {
          char: 'a',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'agora',
      units: 1,
      img: '/img/coins/ils-1-agora.png'
    }]
  },
  IMP: {
    name: 'Manx Pound',
    code: 'IMP',
    fxCode: 'GBP',
    countries: ['Isle of Man (UK)'],
    symbol: {
      char: '£',
      pre: true
    },
    maxDP: 2,
    units: {
      'penny': {
        name: 'penny',
        plural: 'pence',
        symbol: {
          char: 'p',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'penny',
      units: 1,
      img: '/img/coins/imp-1-penny.png'
    }]
  },
  IQD: {
    name: 'Iraqi Dinar',
    code: 'IQD',
    countries: ['Iraq'],
    symbol: {
      char: 'د.ع',
      pre: false
    },
    maxDP: 2,
    units: {
      'dinar': {
        name: 'dinar',
        plural: 'dinars',
        symbol: {
          char: 'د.ع',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'dinar',
      units: 25,
      img: '/img/coins/iqd-25-dinar.png'
    }]
  },
  IRR: {
    name: 'Iranian Rial',
    code: 'IRR',
    countries: ['Iran'],
    symbol: {
      char: '﷼',
      pre: false
    },
    maxDP: 2,
    units: {
      'rial': {
        name: 'rial',
        plural: 'rials',
        symbol: {
          char: '﷼',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'rial',
      units: 50,
      img: '/img/coins/irr-50-rial.png'
    }]
  },
  ISK: {
    name: 'Icelandic Króna',
    code: 'ISK',
    countries: ['Iceland'],
    symbol: {
      char: 'kr',
      pre: false
    },
    maxDP: 2,
    units: {
      'krona': {
        name: 'króna',
        plural: 'krónur',
        symbol: {
          char: 'kr',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'krona',
      units: 1,
      img: '/img/coins/isk-1-krona.png'
    }]
  },
  JMD: {
    name: 'Jamaican Dollar',
    code: 'JMD',
    countries: ['Jamaica'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'dollar': {
        name: 'dollar',
        plural: 'dollars',
        symbol: {
          char: '$',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'dollar',
      units: 1,
      img: '/img/coins/jmd-1-dollar.png'
    }]
  },
  JOD: {
    name: 'Jordanian Dinar',
    code: 'JOD',
    countries: ['Jordan'],
    symbol: {
      char: 'د.أ',
      pre: false
    },
    maxDP: 2,
    units: {
      'qirsh': {
        name: 'qirsh',
        plural: 'qirsh',
        symbol: {
          char: 'q',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'qirsh',
      units: 1,
      img: '/img/coins/jod-1-qirsh.png'
    }]
  },
  KES: {
    name: 'Kenyan Shilling',
    code: 'KES',
    countries: ['Kenya'],
    symbol: {
      char: '/=',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 50,
      img: '/img/coins/kes-50-cent.png'
    }]
  },
  KGS: {
    name: 'Kyrgyzstani Som',
    code: 'KGS',
    countries: ['Kyrgyzstan'],
    symbol: {
      char: 'som',
      pre: false
    },
    maxDP: 2,
    units: {
      'tyiyn': {
        name: 'tyiyn',
        plural: 'tyiyn',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'tyiyn',
      units: 1,
      img: '/img/coins/kgs-1-tyiyn.png'
    }]
  },
  KHR: {
    name: 'Cambodian Riel',
    code: 'KHR',
    countries: ['Cambodia'],
    symbol: {
      char: '៛',
      pre: false
    },
    maxDP: 2,
    units: {
      'riel': {
        name: 'riel',
        plural: 'riel',
        symbol: {
          char: '៛',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'riel',
      units: 1,
      img: '/img/coins/khr-50-riel.png'
    }]
  },
  KID: {
    name: 'Kiribati Dollar',
    code: 'KID',
    fxCode: 'AUD',
    countries: ['Kiribati'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/kid-1-cent.png'
    }]
  },
  KMF: {
    name: 'Comorian Franc',
    code: 'KMF',
    countries: ['Comoros'],
    symbol: {
      char: 'CF',
      pre: false
    },
    maxDP: 2,
    units: {
      'franc': {
        name: 'franc',
        plural: 'francs',
        symbol: {
          char: 'CF',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'franc',
      units: 1,
      img: '/img/coins/kmf-1-franc.png'
    }]
  },
  KPW: {
    name: 'North Korean Won',
    code: 'KPW',
    countries: ['North Korea'],
    symbol: {
      char: '₩',
      pre: true
    },
    maxDP: 2,
    units: {
      'chon': {
        name: 'chon',
        plural: 'chon',
        symbol: {
          char: '전',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'chon',
      units: 1,
      img: '/img/coins/kpw-1-chon.png'
    }]
  },
  KWD: {
    name: 'Kuwaiti Dinar',
    code: 'KWD',
    countries: ['Kuwait'],
    symbol: {
      char: 'د.ك',
      pre: false
    },
    maxDP: 3,
    units: {
      'fils': {
        name: 'fils',
        plural: 'fils',
        symbol: {
          char: 'فلس',
          pre: false
        },
        value: 0.001
      }
    },
    coins: [{
      unit: 'fils',
      units: 1,
      img: '/img/coins/kwd-1-fils.png'
    }]
  },
  KZT: {
    name: 'Kazakhstani Tenge',
    code: 'KZT',
    countries: ['Kazakhstan'],
    symbol: {
      char: '₸',
      pre: false
    },
    maxDP: 2,
    units: {
      'tiyin': {
        name: 'tiyin',
        plural: 'tiyin',
        symbol: {
          char: 'тиын',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'tiyin',
      units: 2,
      img: '/img/coins/kzt-2-tiyin.png'
    }]
  },
  LAK: {
    name: 'Lao Kip',
    code: 'LAK',
    countries: ['Laos'],
    symbol: {
      char: '₭',
      pre: false
    },
    maxDP: 2,
    units: {
      'att': {
        name: 'att',
        plural: 'att',
        symbol: {
          char: 'ອັດ',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'att',
      units: 10,
      img: '/img/coins/lak-10-att.png'
    }]
  },
  LBP: {
    name: 'Lebanese Pound',
    code: 'LBP',
    countries: ['Lebanon'],
    symbol: {
      char: 'ل.ل',
      pre: false
    },
    maxDP: 2,
    units: {
      'pound': {
        name: 'pound',
        plural: 'pounds',
        symbol: {
          char: 'ل.ل',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'pound',
      units: 25,
      img: '/img/coins/lbp-25-pound.png'
    }]
  },
  LKR: {
    name: 'Sri Lankan Rupee',
    code: 'LKR',
    countries: ['Sri Lanka'],
    symbol: {
      char: 'රු',
      pre: true
    },
    maxDP: 2,
    units: {
      'rupee': {
        name: 'rupee',
        plural: 'rupees',
        symbol: {
          char: 'රු',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'rupee',
      units: 1,
      img: '/img/coins/lkr-1-rupee.png'
    }]
  },
  LRD: {
    name: 'Liberian Dollar',
    code: 'LRD',
    countries: ['Liberia'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 5,
      img: '/img/coins/lrd-5-cent.png'
    }]
  },
  LSL: {
    name: 'Lesotho Loti',
    code: 'LSL',
    countries: ['Lesotho'],
    symbol: {
      char: 'M',
      pre: true
    },
    maxDP: 2,
    units: {
      'sente': {
        name: 'sente',
        plural: 'lisente',
        symbol: {
          char: 's',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'sente',
      units: 5,
      img: '/img/coins/lsl-1-sente.png'
    }]
  },
  LYD: {
    name: 'Libyan Dinar',
    code: 'LYD',
    countries: ['Libya'],
    symbol: {
      char: 'ل.د',
      pre: false
    },
    maxDP: 3,
    units: {
      'dirham': {
        name: 'dirham',
        plural: 'dirham',
        symbol: {
          char: 'درهم',
          pre: false
        },
        value: 0.001
      }
    },
    coins: [{
      unit: 'dirham',
      units: 1,
      img: '/img/coins/lyd-1-dirham.png'
    }]
  },
  MAD: {
    name: 'Moroccan Dirham',
    code: 'MAD',
    countries: ['Morocco'],
    symbol: {
      char: 'DH',
      pre: false
    },
    maxDP: 2,
    units: {
      'centime': {
        name: 'centime',
        plural: 'centimes',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centime',
      units: 10,
      img: '/img/coins/mad-10-centime.png'
    }]
  },
  MDL: {
    name: 'Moldovan Leu',
    code: 'MDL',
    countries: ['Moldova'],
    symbol: {
      char: 'L',
      pre: false
    },
    maxDP: 2,
    units: {
      'ban': {
        name: 'ban',
        plural: 'bani',
        symbol: {
          char: 'b',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'ban',
      units: 1,
      img: '/img/coins/mdl-1-ban.png'
    }]
  },
  MGA: {
    name: 'Malagasy Ariary',
    code: 'MGA',
    countries: ['Madagascar'],
    symbol: {
      char: 'Ar',
      pre: false
    },
    maxDP: 2,
    units: {
      'franc': {
        name: 'franc',
        plural: 'francs',
        symbol: {
          char: 'fr',
          pre: false
        },
        value: 0.2
      }
    },
    coins: [{
      unit: 'franc',
      units: 1,
      img: '/img/coins/mga-1-franc.png'
    }]
  },
  MKD: {
    name: 'Macedonian Denar',
    code: 'MKD',
    countries: ['North Macedonia'],
    symbol: {
      char: 'ден',
      pre: false
    },
    maxDP: 2,
    units: {
      'deni': {
        name: 'deni',
        plural: 'deni',
        symbol: {
          char: 'дени',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'deni',
      units: 50,
      img: '/img/coins/mkd-50-deni.png'
    }]
  },
  MMK: {
    name: 'Burmese Kyat',
    code: 'MMK',
    countries: ['Burma'],
    symbol: {
      char: 'K',
      pre: true
    },
    maxDP: 2,
    units: {
      'pya': {
        name: 'pya',
        plural: 'pyas',
        symbol: {
          char: 'p',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'pya',
      units: 25,
      img: '/img/coins/mmk-25-pya.png'
    }]
  },
  MNT: {
    name: 'Mongolian Tögrög',
    code: 'MNT',
    countries: ['Mongolia'],
    symbol: {
      char: '₮',
      pre: true
    },
    maxDP: 2,
    units: {
      'togrog': {
        name: 'tögrög',
        plural: 'tögrög',
        symbol: {
          char: '₮',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'togrog',
      units: 20,
      img: '/img/coins/mnt-20-togrog.png'
    }]
  },
  // MRU: {
  //   name: 'Mauritanian Ouguiya',
  //   code: 'MRU',
  //   countries: ['Mauritania'],
  //   symbol: {
  //     char: 'UM',
  //     pre: false
  //   },
  //   maxDP: 2,
  //   units: {
  //     'khoums': {
  //       name: 'khoums',
  //       plural: 'khoums',
  //       symbol: {
  //         char: 'kh',
  //         pre: true
  //       },
  //       value: 0.2
  //     }
  //   },
  //   coins: [{
  //     unit: 'khoums',
  //     units: 1,
  //     img: '/img/coins/mru-1-khoums.png'
  //   }]
  // },
  MUR: {
    name: 'Mauritian Rupee',
    code: 'MUR',
    countries: ['Mauritius'],
    symbol: {
      char: '₨',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '￠',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/mur-1-cent.png'
    }]
  },
  MVR: {
    name: 'Maldivian Rufiyaa',
    code: 'MVR',
    countries: ['Mauritius'],
    symbol: {
      char: 'ރ',
      pre: true
    },
    maxDP: 2,
    units: {
      'laari': {
        name: 'laari',
        plural: 'laari',
        symbol: {
          char: 'l',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'laari',
      units: 1,
      img: '/img/coins/mvr-1-laari.png'
    }]
  },
  MWK: {
    name: 'Malawian Kwacha',
    code: 'MWK',
    countries: ['Malawi'],
    symbol: {
      char: 'K',
      pre: false
    },
    maxDP: 2,
    units: {
      'tambala': {
        name: 'tambala',
        plural: 'tambala',
        symbol: {
          char: 't',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'tambala',
      units: 1,
      img: '/img/coins/mwk-1-tambala.png'
    }]
  },
  MYR: {
    name: 'Malaysian Ringgit',
    code: 'MYR',
    countries: ['Malaysia'],
    symbol: {
      char: 'RM',
      pre: true
    },
    maxDP: 2,
    units: {
      'sen': {
        name: 'sen',
        plural: 'sen',
        symbol: {
          char: 's',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'sen',
      units: 5,
      img: '/img/coins/myr-5-sen.png'
    }]
  },
  MZN: {
    name: 'Mozambican Metical',
    code: 'MZN',
    countries: ['Mozambique'],
    symbol: {
      char: 'MT',
      pre: false
    },
    maxDP: 2,
    units: {
      'centavo': {
        name: 'centavo',
        plural: 'centavos',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centavo',
      units: 1,
      img: '/img/coins/mzn-1-centavo.png'
    }]
  },
  NAD: {
    name: 'Namibian Dollar',
    code: 'NAD',
    countries: ['Namibia'],
    symbol: {
      char: 'N$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '￠',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 5,
      img: '/img/coins/nad-5-cent.png'
    }]
  },
  NGN: {
    name: 'Nigerian Naira',
    code: 'NGN',
    countries: ['Nigeria'],
    symbol: {
      char: '₦',
      pre: true
    },
    maxDP: 2,
    units: {
      'kobo': {
        name: 'kobo',
        plural: 'kobo',
        symbol: {
          char: 'k',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'kobo',
      units: 50,
      img: '/img/coins/ngn-50-kobo.png'
    }]
  },
  NIO: {
    name: 'Nicaraguan Córdoba',
    code: 'NIO',
    countries: ['Nicaraguan'],
    symbol: {
      char: 'C$',
      pre: true
    },
    maxDP: 2,
    units: {
      'centavo': {
        name: 'centavo',
        plural: 'centavos',
        symbol: {
          char: '￠',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centavo',
      units: 5,
      img: '/img/coins/nio-5-centavo.png'
    }]
  },
  NOK: {
    name: 'Norwegian Krone',
    code: 'NOK',
    countries: ['Norwegian'],
    symbol: {
      char: 'kr',
      pre: false
    },
    maxDP: 2,
    units: {
      'krone': {
        name: 'krone',
        plural: 'kroner',
        symbol: {
          char: 'kr',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'krone',
      units: 1,
      img: '/img/coins/nok-1-krone.png'
    }]
  },
  NPR: {
    name: 'Nepali Rupee',
    code: 'NPR',
    countries: ['Nepal'],
    symbol: {
      char: 'रु',
      pre: true
    },
    maxDP: 2,
    units: {
      'paisa': {
        name: 'paisa',
        plural: 'paisa',
        symbol: {
          char: 'p',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'paisa',
      units: 1,
      img: '/img/coins/npr-1-paisa.png'
    }]
  },
  NZD: {
    name: 'New Zealand Dollar',
    code: 'NZD',
    countries: ['New Zealand'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 10,
      img: '/img/coins/nzd-10-cent.png'
    }]
  },
  OMR: {
    name: 'Omani Rial',
    code: 'OMR',
    countries: ['Oman'],
    symbol: {
      char: 'ر.ع.',
      pre: false
    },
    maxDP: 3,
    units: {
      'baisa': {
        name: 'baisa',
        plural: 'baisa',
        symbol: {
          char: 'بيسة',
          pre: false
        },
        value: 0.001
      }
    },
    coins: [{
      unit: 'baisa',
      units: 5,
      img: '/img/coins/omr-5-baisa.png'
    }]
  },
  PAB: {
    name: 'Panamanian Balboa',
    code: 'PAB',
    fxCode: 'USD',
    countries: ['Panama'],
    symbol: {
      char: 'B/.',
      pre: true
    },
    maxDP: 2,
    units: {
      'centesimo': {
        name: 'centésimo',
        plural: 'centésimos',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centesimo',
      units: 1,
      img: '/img/coins/pab-1-centesimo.png'
    }]
  },
  PEN: {
    name: 'Peruvian Sol',
    code: 'PEN',
    countries: ['Peru'],
    symbol: {
      char: 'S/',
      pre: true
    },
    maxDP: 2,
    units: {
      'centimo': {
        name: 'céntimo',
        plural: 'céntimos',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centimo',
      units: 1,
      img: '/img/coins/pen-1-centimo.png'
    }]
  },
  PGK: {
    name: 'Papua New Guinean Kina',
    code: 'PGK',
    countries: ['Papua New Guinea'],
    symbol: {
      char: 'K',
      pre: true
    },
    maxDP: 2,
    units: {
      'toea': {
        name: 'toea',
        plural: 'toea',
        symbol: {
          char: 't',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'toea',
      units: 5,
      img: '/img/coins/pgk-5-toea.png'
    }]
  },
  PHP: {
    name: 'Philippine Peso',
    code: 'PHP',
    countries: ['The Philippines'],
    symbol: {
      char: '₱',
      pre: true
    },
    maxDP: 2,
    units: {
      'sentimo': {
        name: 'sentimo',
        plural: 'sentimos',
        symbol: {
          char: '￠',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'sentimo',
      units: 1,
      img: '/img/coins/php-1-sentimo.png'
    }]
  },
  PKR: {
    name: 'Pakistani Rupee',
    code: 'PKR',
    countries: ['Pakistan'],
    symbol: {
      char: '₨',
      pre: true
    },
    maxDP: 2,
    units: {
      'rupee': {
        name: 'rupee',
        plural: 'rupees',
        symbol: {
          char: '₨',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'rupee',
      units: 1,
      img: '/img/coins/pkr-1-rupee.png'
    }]
  },
  PLN: {
    name: 'Polish Złoty',
    code: 'PLN',
    countries: ['Poland'],
    symbol: {
      char: 'zł',
      pre: false
    },
    maxDP: 2,
    units: {
      'grosz': {
        name: 'grosz',
        plural: 'grosz',
        symbol: {
          char: 'gr',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'grosz',
      units: 1,
      img: '/img/coins/pln-1-grosz.png'
    }]
  },
  PYG: {
    name: 'Paraguayan Guaraní',
    code: 'PYG',
    countries: ['Paraguay'],
    symbol: {
      char: '₲',
      pre: true
    },
    maxDP: 2,
    units: {
      'guarani': {
        name: 'guaraní',
        plural: 'guaraníes',
        symbol: {
          char: '₲',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'guarani',
      units: 50,
      img: '/img/coins/pyg-50-guarani.png'
    }]
  },
  QAR: {
    name: 'Qatari Riyal',
    code: 'QAR',
    countries: ['Qatar'],
    symbol: {
      char: 'ر.ق',
      pre: false
    },
    maxDP: 2,
    units: {
      'dirham': {
        name: 'dirham',
        plural: 'dirhams',
        symbol: {
          char: 'درهم‎',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'dirham',
      units:1,
      img: '/img/coins/qar-1-dirham.png'
    }]
  },
  RON: {
    name: 'Romanian Leu',
    code: 'RON',
    countries: ['Romania'],
    symbol: {
      char: 'L',
      pre: false
    },
    maxDP: 2,
    units: {
      'ban': {
        name: 'ban',
        plural: 'bani',
        symbol: {
          char: 'b',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'ban',
      units: 1,
      img: '/img/coins/ron-1-ban.png'
    }]
  },
  RSD: {
    name: 'Serbian Dinar',
    code: 'RSD',
    countries: ['Serbia'],
    symbol: {
      char: 'дин',
      pre: false
    },
    maxDP: 2,
    units: {
      'dinar': {
        name: 'dinar',
        plural: 'dinars',
        symbol: {
          char: 'дин',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'dinar',
      units: 1,
      img: '/img/coins/rsd-1-dinar.png'
    }]
  },
  RWF: {
    name: 'Rwandan Franc',
    code: 'RWF',
    countries: ['Rwanda'],
    symbol: {
      char: 'R₣',
      pre: false
    },
    maxDP: 2,
    units: {
      'franc': {
        name: 'franc',
        plural: 'francs',
        symbol: {
          char: 'R₣',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'franc',
      units: 1,
      img: '/img/coins/rwf-1-franc.png'
    }]
  },
  SBD: {
    name: 'Solomon Islands Dollar',
    code: 'SBD',
    countries: ['Solomon Islands'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 10,
      img: '/img/coins/sbd-10-cent.png'
    }]
  },
  SCR: {
    name: 'Seychellois Rupee',
    code: 'SCR',
    countries: ['Seychelles'],
    symbol: {
      char: 'SR',
      pre: false
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '￠',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/scr-1-cent.png'
    }]
  },
  SDG: {
    name: 'Sudanese Pound',
    code: 'SDG',
    countries: ['Sudan'],
    symbol: {
      char: '£',
      pre: true
    },
    maxDP: 2,
    units: {
      'piastre': {
        name: 'piastre',
        plural: 'piastres',
        symbol: {
          char: 'q',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'piastre',
      units: 1,
      img: '/img/coins/sdg-1-piastre.png'
    }]
  },
  SLL: {
    name: 'Sierra Leonean Leone',
    code: 'SLL',
    countries: ['Sierra Leone'],
    symbol: {
      char: 'Le',
      pre: false
    },
    maxDP: 2,
    units: {
      'leone': {
        name: 'leone',
        plural: 'leones',
        symbol: {
          char: 'Le',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'leone',
      units: 10,
      img: '/img/coins/sll-10-leone.png'
    }]
  },
  SLS: {
    name: 'Somaliland Shilling',
    code: 'SLS',
    fxCode: 'USD',
    peg: 8500,
    countries: ['Somaliland'],
    symbol: {
      char: '/-',
      pre: false
    },
    maxDP: 2,
    units: {
      'shilling': {
        name: 'shilling',
        plural: 'shillings',
        symbol: {
          char: '/-',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'shilling',
      units: 1,
      img: '/img/coins/sls-1-shilling.png'
    }]
  },
  SOS: {
    name: 'Somali Shilling',
    code: 'SOS',
    countries: ['Somalia'],
    symbol: {
      char: 'Sh.',
      pre: false
    },
    maxDP: 2,
    units: {
      'senti': {
        name: 'senti',
        plural: 'senti',
        symbol: {
          char: 's',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'senti',
      units: 5,
      img: '/img/coins/sos-5-senti.png'
    }]
  },
  SRD: {
    name: 'Surinamese Dollar',
    code: 'SRD',
    countries: ['Suriname'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/srd-1-cent.png'
    }]
  },
  STN: {
    name: 'São Tomé and Príncipe Dobra',
    code: 'STN',
    fxCode: 'EUR',
    peg: 24.50,
    countries: ['São Tomé and Príncipe'],
    symbol: {
      char: 'Db',
      pre: true
    },
    maxDP: 2,
    units: {
      'centimo': {
        name: 'cêntimo',
        plural: 'cêntimos',
        symbol: {
          char: 'c',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'centimo',
      units: 10,
      img: '/img/coins/stn-10-centimo.png'
    }]
  },
  SYP: {
    name: 'Syrian Pound',
    code: 'SYP',
    countries: ['Syria'],
    symbol: {
      char: '£S',
      pre: false
    },
    maxDP: 2,
    units: {
      'pound': {
        name: 'pound',
        plural: 'pounds',
        symbol: {
          char: '£S',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'pound',
      units: 5,
      img: '/img/coins/syp-5-pound.png'
    }]
  },
  THB: {
    name: 'Thai Baht',
    code: 'THB',
    countries: ['Thailand'],
    symbol: {
      char: '฿',
      pre: true
    },
    maxDP: 2,
    units: {
      'satang': {
        name: 'satang',
        plural: 'satang',
        symbol: {
          char: 's',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'satang',
      units: 1,
      img: '/img/coins/thb-1-satang.png'
    }]
  },
  TJS: {
    name: 'Tajikistani Somoni',
    code: 'TJS',
    countries: ['Tajikistan'],
    symbol: {
      char: 'SM',
      pre: true
    },
    maxDP: 2,
    units: {
      'diram': {
        name: 'diram',
        plural: 'diram',
        symbol: {
          char: 'd',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'diram',
      units: 5,
      img: '/img/coins/tjs-5-diram.png'
    }]
  },
  TMT: {
    name: 'Turkmenistani Manat',
    code: 'TMT',
    countries: ['Turkmenistan'],
    symbol: {
      char: 'm',
      pre: false
    },
    maxDP: 2,
    units: {
      'tenge': {
        name: 'tenge',
        plural: 'tenge',
        symbol: {
          char: 'T',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'tenge',
      units: 1,
      img: '/img/coins/tmt-1-tenge.png'
    }]
  },
  TND: {
    name: 'Tunisian Dinar',
    code: 'TND',
    countries: ['Tunisia'],
    symbol: {
      char: 'د.ت',
      pre: false
    },
    maxDP: 3,
    units: {
      'millime': {
        name: 'millime',
        plural: 'millimes',
        symbol: {
          char: 'ملّيم',
          pre: false
        },
        value: 0.001
      }
    },
    coins: [{
      unit: 'millime',
      units: 1,
      img: '/img/coins/tnd-1-millime.png'
    }]
  },
  TOP: {
    name: 'Tongan paʻanga',
    code: 'TOP',
    countries: ['Tonga'],
    symbol: {
      char: 'T$',
      pre: true
    },
    maxDP: 2,
    units: {
      'seniti': {
        name: 'seniti',
        plural: 'seniti',
        symbol: {
          char: '￠',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'seniti',
      units: 1,
      img: '/img/coins/top-1-seniti.png'
    }]
  },
  TTD: {
    name: 'Trinidad and Tobago Dollar',
    code: 'TTD',
    countries: ['Trinidad and Tobago'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 5,
      img: '/img/coins/ttd-5-cent.png'
    }]
  },
  TVD: {
    name: 'Tuvaluan Dollar',
    code: 'TVD',
    fxCode: 'AUD',
    countries: ['Tuvalu'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 1,
      img: '/img/coins/tvd-1-cent.png'
    }]
  },
  TWD: {
    name: 'New Taiwan Dollar',
    code: 'TWD',
    countries: ['Taiwan'],
    symbol: {
      char: '圓',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 50,
      img: '/img/coins/twd-50-cent.png'
    }]
  },
  TZS: {
    name: 'Tanzanian Shilling',
    code: 'TZS',
    countries: ['Tanzania'],
    symbol: {
      char: '/=',
      pre: true
    },
    maxDP: 2,
    units: {
      'senti': {
        name: 'senti',
        plural: 'senti',
        symbol: {
          char: 's',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'senti',
      units: 5,
      img: '/img/coins/tzs-5-senti.png'
    }]
  },
  UAH: {
    name: 'Ukrainian Hryvnia',
    code: 'UAH',
    countries: ['Ukraine'],
    symbol: {
      char: '₴',
      pre: true
    },
    maxDP: 2,
    units: {
      'kopiyka': {
        name: 'kopiyka',
        plural: 'kopiyky',
        symbol: {
          char: 'k',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'kopiyka',
      units: 1,
      img: '/img/coins/uah-1-kopiyka.png'
    }]
  },
  UGX: {
    name: 'Ugandan Shilling',
    code: 'UGX',
    countries: ['Uganda'],
    symbol: {
      char: 'USh',
      pre: false
    },
    maxDP: 2,
    units: {
      'shilling': {
        name: 'shilling',
        plural: 'shillings',
        symbol: {
          char: 'USh',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'shilling',
      units: 1,
      img: '/img/coins/ugx-1-shilling.png'
    }]
  },
  UYU: {
    name: 'Uruguayan Peso',
    code: 'UYU',
    countries: ['Uruguay'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'peso': {
        name: 'peso',
        plural: 'pesos',
        symbol: {
          char: '$',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'peso',
      units: 1,
      img: '/img/coins/uyu-1-peso.png'
    }]
  },
  UZS: {
    name: 'Uzbekistani Soʻm',
    code: 'UZS',
    countries: ['Uzbekistan'],
    symbol: {
      char: 'сум',
      pre: false
    },
    maxDP: 2,
    units: {
      'som': {
        name: 'Soʻm',
        plural: 'Soʻm',
        symbol: {
          char: 'сум',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'som',
      units: 50,
      img: '/img/coins/uzs-50-som.png'
    }]
  },
  // VES: {
  //   name: 'Venezualan Bolívar',
  //   code: 'VES',
  //   countries: ['Venezuela'],
  //   symbol: {
  //     char: 'B$',
  //     pre: true
  //   },
  //   maxDP: 2,
  //   units: {
  //     'centimo': {
  //       name: 'céntimo',
  //       plural: 'céntimos',
  //       symbol: {
  //         char: 'c',
  //         pre: false
  //       },
  //       value: 0.01
  //     }
  //   },
  //   coins: [{
  //     unit: 'centimo',
  //     units: 50,
  //     img: '/img/coins/ves-50-centimo.png'
  //   }]
  // },
  VND: {
    name: 'Vietnamese đồng',
    code: 'VND',
    countries: ['Vietnam'],
    symbol: {
      char: '₫',
      pre: false
    },
    maxDP: 2,
    units: {
      'dong': {
        name: 'đồng',
        plural: 'đồng',
        symbol: {
          char: '₫',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'dong',
      units: 200,
      img: '/img/coins/vnd-200-dong.png'
    }]
  },
  VUV: {
    name: 'Vanuatu Vatu',
    code: 'VUV',
    countries: ['Vanuatu'],
    symbol: {
      char: 'VT',
      pre: false
    },
    maxDP: 2,
    units: {
      'vatu': {
        name: 'vatu',
        plural: 'vatu',
        symbol: {
          char: 'VT',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'vatu',
      units: 1,
      img: '/img/coins/vuv-1-vatu.png'
    }]
  },
  WST: {
    name: 'Samoan Tālā',
    code: 'WST',
    countries: ['Samoa'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'sene': {
        name: 'sene',
        plural: 'sene',
        symbol: {
          char: 's',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'sene',
      units: 1,
      img: '/img/coins/wst-1-sene.png'
    }]
  },
  XAF: {
    name: 'Central African CFA Franc',
    code: 'XAF',
    fxCode: 'EUR',
    peg: 655.957,
    countries: ['Cameroon', 'Central African Republic', 'Chad', 'Republic of the Congo', 'Equatorial Guinea', 'Gabon'],
    symbol: {
      char: 'FCFA',
      pre: false
    },
    maxDP: 2,
    units: {
      'franc': {
        name: 'franc',
        plural: 'franc',
        symbol: {
          char: 'FCFA',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'franc',
      units: 1,
      img: '/img/coins/xaf-1-franc.png'
    }]
  },
  XCD: {
    name: 'Eastern Caribbean Dollar',
    code: 'XCD',
    fxCode: 'USD',
    peg: 2.70,
    countries: ['Anguilla', 'Antigua and Barbuda', 'Dominica', 'Grenada', 'Montserrat', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines'],
    symbol: {
      char: '$',
      pre: true
    },
    maxDP: 2,
    units: {
      'cent': {
        name: 'cent',
        plural: 'cents',
        symbol: {
          char: '¢',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'cent',
      units: 5,
      img: '/img/coins/xcd-5-cent.png'
    }]
  },
  XPF: {
    name: 'CFP Franc',
    code: 'XPF',
    fxCode: 'EUR',
    peg: 119.332,
    countries: ['French Polynesia', 'New Caledonia', 'Wallis and Futuna'],
    symbol: {
      char: '	₣',
      pre: true
    },
    maxDP: 2,
    units: {
      'franc': {
        name: 'franc',
        plural: 'franc',
        symbol: {
          char: '	₣',
          pre: true
        },
        value: 1
      }
    },
    coins: [{
      unit: 'franc',
      units: 1,
      img: '/img/coins/xpf-1-franc.png'
    }]
  },
  XOF: {
    name: 'West African CFA Franc',
    code: 'XOF',
    fxCode: 'EUR',
    peg: 655.957,
    countries: ['Benin', 'Burkina Faso', 'Côte d\'Ivoire', 'Guinea-Bissau', 'Mali', 'Niger', 'Senegal', 'Togo'],
    symbol: {
      char: 'CFA',
      pre: false
    },
    maxDP: 2,
    units: {
      'franc': {
        name: 'franc',
        plural: 'franc',
        symbol: {
          char: 'CFA',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'franc',
      units: 1,
      img: '/img/coins/xof-1-franc.png'
    }]
  },
  YER: {
    name: 'Yemeni Rial',
    code: 'YER',
    countries: ['Yemen'],
    symbol: {
      char: '﷼',
      pre: false
    },
    maxDP: 2,
    units: {
      'rial': {
        name: 'rial',
        plural: 'rials',
        symbol: {
          char: '﷼',
          pre: false
        },
        value: 1
      }
    },
    coins: [{
      unit: 'rial',
      units: 1,
      img: '/img/coins/yer-1-rial.png'
    }]
  },
  ZMW: {
    name: 'Zambian Kwacha',
    code: 'ZMW',
    countries: ['Zambia'],
    symbol: {
      char: 'K',
      pre: false
    },
    maxDP: 2,
    units: {
      'ngwee': {
        name: 'ngwee',
        plural: 'ngwee',
        symbol: {
          char: 't',
          pre: false
        },
        value: 0.01
      }
    },
    coins: [{
      unit: 'ngwee',
      units: 1,
      img: '/img/coins/zmw-1-ngwee.png'
    }]
  },
}
